import React, { Component } from 'react';
import { connect } from 'react-redux';
import Register from '../../components/Register';
import keycloakService from '../../keycloakService';
import { validateUser } from '../../utils/helper';
import { register } from '../../actions/userAction';
import Header from '../../components/Header';

class Registration extends Component {
  constructor() {
    super();
    this.state = {
      userData: {
        firstName: '',
        lastName: '',
        email: '',
        userName: '',
        password: '',
        confirmPassword: '',
        promoCode: ''
      },
      errors: {},
      isRegistrationSuccess: false,
      serverErrorMsg: '',
      isSubmitting: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { userData, errors } = this.state;
    const { name, value } = e.target;
    userData[name] = value;
    errors[name] = '';
    this.setState({ userData, errors, serverErrorMsg: '' });
  }
  handleLogin() {
    keycloakService.login();
  }

  handleSubmit(e) {
    e.preventDefault();
    const { userData } = this.state;
    const { register } = this.props;
    const { isValid, validationErrors } = validateUser(userData);
    if (!isValid) {
      this.setState({ errors: validationErrors });
    } else {
      this.setState({ isSubmitting: true });
      delete userData.confirmPassword;
      register(
        userData,
        () => {
          this.setState({ isSubmitting: false, isRegistrationSuccess: true });
        },
        (e) => {
          const { response } = e;
          const message =
            response && response.status === 409
              ? response.data
              : 'Please check your details and try again!';
          this.setState({
            isSubmitting: false,
            serverErrorMsg: message
          });
        }
      );
    }
  }

  render() {
    const { errors, isRegistrationSuccess, serverErrorMsg, isSubmitting } = this.state;
    return (
      <div>
        <Header />
        <Register
          handleLogin={this.handleLogin}
          handleSubmit={this.handleSubmit}
          handleChange={this.handleChange}
          handlePromoCode={this.handlePromoCode}
          isRegistrationSuccess={isRegistrationSuccess}
          serverErrorMsg={serverErrorMsg}
          validationErrors={errors}
          isSubmitting={isSubmitting}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {
  register
};

export default connect(null, mapDispatchToProps)(Registration);
